import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Copy } from '../../../Assets/SVGS'
import BtnLoader from '../../common/BtnLoader/BtnLoader'
import './Vcash.css'
function Vcash(){
  const { t } = useTranslation();
  const inputRef = useRef()
  const [copy , setCopy] = useState(false)
  const [image , setImage] = useState(null)
  const [loader , setLoader] = useState(false)
  const handleCopy = async()=>{
    try{
      navigator.clipboard.writeText("01111039794")
      setCopy(true)
      setTimeout(() => {
        setCopy(false);
      }, 1000);
    }
    catch{
      setCopy(false)
    }
  }
  const uploadImage = (e)=>{
    setLoader(true)
    setTimeout(()=>{
      setLoader(false)
    },1000)
    setImage(e.target.files[0])
  }
  return (
    <div className='vcash-container'>
      <div className='vcash-content'>
        <div>
          <p>
            {t('transferToNumber')} <span>01111039794</span>
          </p>
          <p onClick={() => handleCopy()}>
            {copy ? t('copied') : t('copy')}
            <Copy width='18px' />
          </p>
        </div>
        <span>
          <mark>{t('notes')}</mark>
        </span>
        <ul>
          <li>
            {t('transferVcash')}
          </li>
          <li>{t('saveScreenshot')}</li>
        </ul>
        <p></p>
        <input
          ref={inputRef}
          type='file'
          onChange={(e) => uploadImage(e)}
          name=''
          id=''
        />
        {loader ? (
          <BtnLoader />
        ) : (
          <button className='addBtn' onClick={() => inputRef.current.click()}>
            {image ? t('save') : t('uploadScreen')}
          </button>
        )}
      </div>
    </div>
  );
}
export default Vcash